import Project1 from "../assets/language.png";
import Project2 from "../assets/store.png";
import Project3 from "../assets/tableau.png";
import Project4 from "../assets/stopwatch.png";
import Project5 from "../assets/trivia.png";
import Project6 from "../assets/agile.png";
export const ProjectList = [
  {
    name: "Language Translator",
    image: Project1,
    skills: "JavaScript,HTML,CSS",
    linkToPage: "http://translator-uzair.s3-website.us-east-2.amazonaws.com/",
  },
{
    name: "E-Commerce Shoe Store",
    image: Project2,
    skills: "JavaScript,HTML,CSS",
    linkToPage: "https://ecommerce-uzair.s3.us-east-2.amazonaws.com/ecommerce/index.html",
  },
{
    name: "Data Careers Dashboard",
    image: Project3,
    skills: "JavaScript,HTML,CSS",
    linkToPage: "https://public.tableau.com/app/profile/uzair.jeelani/viz/IndividualTableau_17105550405870/GlobalDataCareers",
  },
{
    name: "Stop Watch",
    image: Project4,
    skills: "JavaScript,HTML,CSS",
    linkToPage: "https://stopwatch-uzair.s3.us-east-2.amazonaws.com/stop+watch/index.html",
  },
{
    name: "Niner Trivia",
    image: Project5,
    skills: "JavaScript,HTML,CSS",
    linkToPage: "https://webpages.charlotte.edu/ujeelani/itis3135/lab9/index.html",
  },
{
    name: "Agile Blog Posts",
    image: Project6,
    skills: "JavaScript,HTML,CSS",
    linkToPage: "https://adunny.wixsite.com/planet-agile",
  },
];